import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'

import LinkButton from 'components/atoms/buttons/LinkButton'

const styles = theme => ({
  root: {
    textAlign: 'center',
    padding: `${theme.spacing(6) * 2}px 0`,
  },
  text: {
    maxWidth: 540,
    margin: '0 auto',
    marginTop: theme.spacing(1),
  },
  actionButton: {
    marginTop: theme.spacing(3),
  },
})

const TablePlaceholder = ({
  classes, title, text, linkTo, linkLabel
}) => (
  <section className={classes.root}>
    <Typography variant="h1">{title}</Typography>
    <Typography className={classes.text}>{text}</Typography>
    {linkTo && linkLabel && (
      <LinkButton
        className={classes.actionButton}
        to={linkTo}
        label={linkLabel}
      />
    )}
  </section>
)

TablePlaceholder.defaultProps = {
  title: 'No Results',
  text: 'Oops, there are no results!',
}

TablePlaceholder.propTypes = {
  text: PropTypes.string,
  title: PropTypes.string,
  linkTo: PropTypes.string,
  classes: PropTypes.object,
  linkLabel: PropTypes.string,
}

export default withStyles(styles)(TablePlaceholder)



// WEBPACK FOOTER //
// ./src/components/atoms/TablePlaceholder.js